import { type Element, Node } from 'slate';
import { defaultFontList } from '../plugins/Formatting/FontFamilyPlugin/fontList';
import { type CSSProperties } from 'react';

export function getFirstTextChildMarks(node: Element) {
  const nodeEntry = Node.texts(node).next();
  if (!nodeEntry.value?.length) return {};

  const [textNode] = nodeEntry.value;
  const { text, ...marks } = textNode;
  return marks;
}

export function getStyleFromChildMarks(node: Element) {
  const style: CSSProperties = {};
  const marks = getFirstTextChildMarks(node);
  for (const mark in marks) {
    const markValue = marks[mark];
    switch (mark) {
      case 'textHighlight':
        // Background doesn't feel right on lists. Ignore it.
        break;
      // No case for textHighlight, see "background doesn't feel right on lists" above.
      case 'textColor':
        style.color = markValue;
        break;
      case 'fontSize':
        style.fontSize = markValue;
        break;
      case 'fontFamily':
        {
          const fontItem = defaultFontList.find(
            (font) => font.styleName === markValue
          );
          style.fontFamily = fontItem
            ? fontItem.fontFamily
            : markValue.split('_').join(' ');
        }
        break;
      default:
        break;
    }
  }
  return style;
}
